import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getVideo } from 'api/Video';

export const useVideo = ({ params = {}, options = {}, dependencies = [] } = {}) => {
  const navigate = useNavigate();

  const { video_id, file_name } = params;

  return useQuery({
    queryKey: ['video', video_id, file_name, ...dependencies],
    queryFn: () => getVideo(navigate, params),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    ...options
  });
};
